'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('./config');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_config).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-config-provider/dist/main/reducers/index.js
// module id = 513
// module chunks = 0